import React from 'react';
import { Button, Heading, PageLevelNotification, Surface } from '@americanexpress/dls-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Formik, Form } from 'formik';
import { ONBOARDING_VALUES, validationSchema } from './onboardingFormHelper';
import OnboardingDetails from './OnboardingDetails';
import TermsAndConditions from './TermsAndConditions';
import Divider from './Divider';
import useOnboarding from './useOnboarding';
const OnboardingForm = () => {
  const {
    handleSubmit,
    isLoading,
    isOnboardingError,
    isOnboardingSuccess,
    dismissNotification
  } = useOnboarding();
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: "container-responsive margin-center pad-responsive"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 1,
    variant: "sans-large-bold",
    className: "margin-responsive-b"
  }, formatMessage({
    id: 'registration.pageTitle'
  })), /*#__PURE__*/React.createElement(PageLevelNotification, {
    type: "success",
    isIconFilled: true,
    onDismiss: dismissNotification,
    className: "margin-2",
    defaultShow: isOnboardingSuccess,
    role: "status",
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "registration.notification.success"
  })), /*#__PURE__*/React.createElement(PageLevelNotification, {
    type: "critical",
    isIconFilled: true,
    onDismiss: dismissNotification,
    className: "margin-2",
    defaultShow: isOnboardingError,
    role: "alert",
    "aria-live": "assertive"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "registration.notification.error"
  })), /*#__PURE__*/React.createElement(Surface, {
    variant: "foreground",
    className: "pad-4 radius-container shadow-2"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: ONBOARDING_VALUES,
    validationSchema: validationSchema,
    onSubmit: handleSubmit
  }, () => /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(OnboardingDetails, null), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(TermsAndConditions, null), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-justify-end margin-responsive-t"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "primary",
    isLoading: isLoading
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "general.button.submit"
  })))))));
};
export default OnboardingForm;